import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const IR35PageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.ir35.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.ir35.banner.image", src: "/assets/banners/ir35.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.ir35.banner.text.${locale}`} className="me-4" />
        </Col>
      </Row>
    </Banner>
  );
};
